module.exports = __webpack_public_path__ + "assets/img/clyh.364d3d92.png";